import { BListGroupItem } from "bootstrap-vue";
import { createEgBootstrapProxy } from "../createEgBootstrapProxy";

export const EgBListGroupItem = createEgBootstrapProxy(
  "EgBListGroupItem",
  BListGroupItem
);
